// Module
var code = `<form novalidate name="\$ctrl.form">
  <label class="pull-right selectable-list__header" ng-if="\$ctrl.hasCheckboxes()">
    <input type="checkbox"
           ng-model="\$ctrl.allSelected"
           is-partially-selected="\$ctrl.isPartiallySelected"
           ng-change="\$ctrl.selectAllCustomers()">&nbsp;&nbsp;Select All
  </label>
  <table class="table">
    <thead>
      <th>No.</th>
      <th>Customer name</th>
      <th>Birth Date</th>
      <th>Mother Branch</th>
      <th>Customer Number</th>
      <th ng-if="\$ctrl.editMode">Active loans</th>
      <th ng-if="\$ctrl.editMode">Loans</th>
      <th ng-if="\$ctrl.editMode">Outstanding Principal</th>
      <th ng-if="\$ctrl.editMode">Savings Balance</th>
      <th ng-if="\$ctrl.isAnyActionAvailable()">Action</th>
    </thead>
    <tbody class="tbody">
    <tr ng-repeat="cst in \$ctrl.profile.customers">
      <td>{{\$index+1}}.</td>
      <td>
        {{cst.effectiveName}}
      </td>
      <td>
        {{cst.individualData.birthDate | prettyDate}}
      </td>
      <td>
        {{cst.branch.name}}
      </td>
      <td>
        {{cst.customerNumber}}
      </td>
      <td ng-if="\$ctrl.editMode">
        {{\$ctrl.loansCount[cst.id].active || 0}}
      </td>
      <td ng-if="\$ctrl.editMode">
        {{\$ctrl.loansCount[cst.id].total || 0}}
      </td>
      <td ng-if="\$ctrl.editMode">
        {{\$ctrl.loansCount[cst.id].principalBalance | nxCurrency}}
      </td>
      <td ng-if="\$ctrl.editMode">
        {{\$ctrl.loansCount[cst.id].savingsBalance | nxCurrency}}
      </td>
      <td ng-if="\$ctrl.isAnyActionAvailable()">
        <button type="button"
                class="btn btn-danger"
                ng-if="!\$ctrl.editMode"
                ng-click="\$ctrl.onRemoveMember(\$index)" >
          Remove
        </button>
        <input type="checkbox"
               ng-if="\$ctrl.canTransferCustomer(cst)"
               ng-checked="\$ctrl.transferList.indexOf(cst.id) !== -1"
               ng-click="\$ctrl.toggleCustomerSelection(cst.id)">
      </td>
    </tr>
    <tr ng-if="\$ctrl.editMode">
      <td></td>
      <td><b>Summary:</b></td>
      <td></td>
      <td></td>
      <td></td>
      <td><b>{{\$ctrl.summary.active}}</b></td>
      <td><b>{{\$ctrl.summary.total}}</b></td>
      <td><b>{{\$ctrl.summary.principalBalance | nxCurrency}}</b></td>
      <td><b>{{\$ctrl.summary.savingsBalance | nxCurrency}}</b></td>
      <td ng-if="\$ctrl.isAnyActionAvailable()"></td>
    </tr>
    <tr>
      <td></td>
      <td colspan="8">
        <customer-picker
            on-choose="\$ctrl.addMember(customer)"
            search-criteria="{customerTypes: ['INDIVIDUAL']}"
        >
        </customer-picker>
      </td>
      <td>
          <button type="button"
                  class="btn btn-primary"
                  style="flex: 1; margin: 0; padding: 9px;"
                  ng-disabled="\$ctrl.transferList.length === 0"
                  ng-click="\$ctrl.transferMembers()">
            Transfer
          </button>
      </td>
    </tr>
    </tbody>
  </table>

  <div class="clearfix"></div>
</form>
`;
// Exports
var _module_exports = code;;
var path = 'src/app/components/customer/group-loans/profile/sub-components/add-group-members.template.html';
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, _module_exports) }]);
module.exports = path;